import { useEffect, useState } from 'react';
import { toast } from '../../../../core/components/atoms/Toast';
import useUserMemory from '../use-user-memory';
import { tagService } from '../../queries/tag';

export const enum TAG_TYPE {
  DISCIPLINA = 'DISCIPLINA',
  MODULO = 'MODULO',
  ASSUNTO = 'ASSUNTO',
  AREA_PROVA = 'AREA_PROVA',
}

const useTags = (type?: TAG_TYPE) => {
  const { memoryUserUuid } = useUserMemory();
  const userUuid = memoryUserUuid;

  const [tags, setTags] = useState<Tag[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchTags = async () => {
    if (!userUuid) return;
    try {
      setIsLoading(true);
      const tags = await tagService.list(userUuid, type);
      setTags(tags);
    } catch (error) {
      console.error(error);
      toast({
        title: 'Erro ao buscar tags',
        message: 'Tente novamente mais tarde',
        variant: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTags();
  }, [userUuid]);

  return {
    tags,
    fetchTags,
    isLoading,
  };
};

export default useTags;
